// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompressOutlinedSvg from "@ant-design/icons-svg/es/asn/CompressOutlined";
import AntdIcon from '../components/AntdIcon';

var CompressOutlined = function CompressOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompressOutlinedSvg
  }));
};

CompressOutlined.displayName = 'CompressOutlined';
export default React.forwardRef(CompressOutlined);